import { useState } from 'react';
import { Grid2 as Grid } from '@mui/material';
import { DateTimePicker, DateTimeValidationError, PickerChangeHandlerContext } from '@mui/x-date-pickers';
import { AUDIT_LOGS_TEST_IDS } from 'pages/AuditLogs/AuditLogs.testIds';

const DateRangeFilter = ({
  onDateRangeChange,
}: {
  onDateRangeChange: (startDate: Date | null, endDate: Date | null) => void;
}) => {
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);

  const handleStartDateChange = (
    newDate: Date | null,
    context: PickerChangeHandlerContext<DateTimeValidationError>
  ) => {
    setStartDate(newDate);
    if (!context.validationError) {
      onDateRangeChange(newDate, endDate);
    }
  };

  const handleEndDateChange = (newDate: Date | null, context: PickerChangeHandlerContext<DateTimeValidationError>) => {
    setEndDate(newDate);
    if (!context.validationError) {
      onDateRangeChange(startDate, newDate);
    }
  };

  return (
    <>
      <Grid>
        <DateTimePicker label="Start date" value={startDate} onChange={handleStartDateChange} slotProps={{ textField: {inputProps: { 'data-testid': AUDIT_LOGS_TEST_IDS.startDateInput}}}}/>
      </Grid>
      <Grid>
        <DateTimePicker label="End date" value={endDate} onChange={handleEndDateChange} slotProps={{ textField: { inputProps: { 'data-testid': AUDIT_LOGS_TEST_IDS.endDateInput}}}}/>
      </Grid>
    </>
  );
};

export default DateRangeFilter;
